module.exports = __webpack_public_path__ + "static/img/usinessPartner_04.e495e05e.jpg";